var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNordiccombined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "36.663 3.222 40.815 1.879 43.913 3.708 44.254 6.272 45.45 8.394 43.744 9.235 42.502 11.2 40.815 10.952 38.13 12.253 35.466 8.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m44.096 2.715.093 3.01-7.93-.846c.143-6.51 7.578-5.731 7.837-2.164l0 0Zm-11.693 6.67 1.263.167 2.999 4.61-7.23 13.928-8.327 11.578-7.489 1.881 8.872-15.24 3.208-8.727 1.107-.219.27-.053.247-.12c3.547-1.734 5.169-4.41 5.08-7.806Zm-2.124-.229c.147 2.448-.75 4.605-3.885 6.137l-11.888 2.358 1.61-2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.269 9.014c.051.677.026 1.333-.102 1.96-.355 1.68-1.449 3.153-3.767 4.285l-12.057 2.391 1.664-3.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "11.067 15.626 13.423 14.864 11.825 17.824 9.863 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "9.895 20.988 12.357 20.532 11.907 22.129 9.381 22.129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m35.166 11.857 1.499 2.305-7.23 13.928-8.327 11.578-3.555.894c.986-1.218 3.351-4.675 9.665-13.594l7.948-15.111Z",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m42.956 30.479 2.679.872-.437 1.338c-.793 2.432-2.412 4.513-4.576 5.882l-.281.179c-2.248 1.422-4.708 2.477-7.288 3.124l-31 7.783-1.366.343-.687-2.73 1.366-.342 31-7.783c2.29-.575 4.472-1.51 6.466-2.773l.282-.178c1.61-1.019 2.815-2.567 3.405-4.377l.437-1.338Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "14.802 19.73 23.076 18.1 21.925 21.114 14.378 21.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "m41.789 4.62 2.4.233.249 1.703c0 1.362-2.91 1.165-2.836-.247l.187-1.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#282828",
    points: "36.311 4.027 44.138 4.853 42.177 5.653 36.232 5.09"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordiccombined);
export default __webpack_public_path__ + "static/media/nordiccombined.21e5870c8bc2edb53763aca2d3369889.svg";
export { ForwardRef as ReactComponent };